import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { PlaceType } from '../constants/PlaceType';
import { PointType } from '../constants/PointType';
import Places from '../services/places';

export const useGetSavedPlacesList = () => {

  const [ savedPlaces, setSavedPlaces ] = useState([]);

  const { data } = useQuery(['savedPlace'], Places.getSavedPlaces, {
    refetchOnWindowFocus: false,
  });

  const getAirportDescription = (item) => {
    return `${item?.airport?.name}, ${item?.address?.state} ${item.address?.zip}, ${item.address?.country}`
  };

  const getPlaceDescription = (item) => {
    return item?.userLabel || item.type;
  };

  const sort = newPlaces => {
    const home = newPlaces.filter((item) => item.type === PointType.HOME);
    const work = newPlaces.filter((item) => item.type === PointType.WORK);
    const savedPlaces = newPlaces.filter((item) => item.type === PointType.SAVED_PLACE);

    return [...home, ...work, ...savedPlaces];
  }

  useEffect(
    () => {
        if (data?.length) {
          const newPlaces = data.reduce((places, item) => {
            places.push({
              description: item.placeType === PlaceType.AIRPORT ? getAirportDescription(item) : getPlaceDescription(item),
              type: item.type,
              placeType: item.placeType,
              address: item.address,
            })
            return places;
          }, []);
          setSavedPlaces(sort(newPlaces));
        }
    }, [ data ]
  );

  return savedPlaces;
};


